import { useState } from "react";
import { toast } from "react-toastify";

export const usePhotoSelection = (getDisplayedPhotos) => {
  const [selectionMode, setSelectionMode] = useState(false);
  const [selectedPhotos, setSelectedPhotos] = useState(new Set());

  // Select/deselect single photo
  const togglePhotoSelection = (photoId) => {
    const newSelected = new Set(selectedPhotos);
    if (newSelected.has(photoId)) {
      newSelected.delete(photoId);
    } else {
      newSelected.add(photoId);
    }
    setSelectedPhotos(newSelected);
  };

  // Select all photos
  const selectAllPhotos = () => {
    const displayedPhotos = getDisplayedPhotos();
    const allIds = new Set(displayedPhotos.map((p) => p._id || p.filePath));
    setSelectedPhotos(allIds);
    toast.success(`✨ Selected all ${allIds.size} photos`);
  };

  // Deselect all photos
  const deselectAllPhotos = () => {
    setSelectedPhotos(new Set());
    toast.info("Deselected all photos");
  };

  return {
    selectionMode,
    setSelectionMode,
    selectedPhotos,
    setSelectedPhotos,
    togglePhotoSelection,
    selectAllPhotos,
    deselectAllPhotos,
  };
};
